import React, { useContext, useEffect } from 'react';
import { DateTime } from 'luxon';

import { media } from 'context';
import { Layout, Link, ProductImg, Text } from 'ds';
import { FURNITURE_PATH } from 'routes';

import OrderProgressBar from './OrderProgressBar';
import { FurnitureOrderWidgetData } from './types';
import { formatDeliveryDate } from './utils';

interface Props {
  data: FurnitureOrderWidgetData;
}

let animateProgressBar = true;

const FurnitureOrderWidget: React.FC<Props> = ({ data: { id, delivery_date, image, description, status, count } }) => {
  const { isMobile } = useContext(media);
  const deliveryDate = delivery_date
    ? formatDeliveryDate({ date: delivery_date, format: { month: 'short', day: 'numeric' } })
    : null;

  const showCountBadge = count && count > 1;

  const arrivingToday = delivery_date
    ? DateTime.fromISO(delivery_date).startOf('day').equals(DateTime.now().startOf('day'))
    : false;

  const progressPercent = arrivingToday
    ? 90
    : {
        pending: 10,
        scheduled: 50,
        completed: 100
      }[status];

  useEffect(() => {
    setTimeout(() => {
      animateProgressBar = false;
    }, 1000);
  }, []);

  return (
    <Link href={`${FURNITURE_PATH}/orders`} search={`order_id=${id}`} color="black" fullWidth fullHeight>
      <Layout
        width={isMobile ? '100%' : undefined}
        borderRadius={16}
        color="white"
        paddingLeft={12}
        paddingRight={20}
        align="center"
        gap={16}
        height="100%"
      >
        {showCountBadge ? (
          <Layout position="relative" width={56} height={56}>
            <ProductImg
              srcKey={image?.key}
              size="thumbnail"
              alt={description}
              style={{ width: 56, height: 56, borderRadius: 8, backgroundColor: 'white' }}
            />
            <Layout
              position="absolute"
              bottom={4}
              right={4}
              width={22}
              height={22}
              borderRadius={4}
              color="white"
              flex
              align="center"
              justify="center"
              boxShadow="0px 2px 4px 0px rgba(0, 0, 0, 0.1)"
            >
              <Text size="tag" bold align="center">
                +{count - 1}
              </Text>
            </Layout>
          </Layout>
        ) : (
          <ProductImg
            srcKey={image?.key}
            size="thumbnail"
            alt={description}
            style={{ width: 56, height: 56, borderRadius: 8, backgroundColor: 'white' }}
          />
        )}
        <Layout direction="column" gap={4} flexGrow={1}>
          <Text size="body-xs">Furniture {isMobile ? '' : 'order'}</Text>
          {!isMobile && <OrderProgressBar progressPercent={progressPercent} animate={animateProgressBar} />}
          <Text size="body-xs" color="gray-400">
            {deliveryDate}
          </Text>
        </Layout>
      </Layout>
    </Link>
  );
};

export default FurnitureOrderWidget;
